import React from 'react';
import BottomNav from './BottomNav';

export default function Layout({ children }) {
  return (
    <div style={{ minHeight: '100vh', position: 'relative' }}>
      <main className="layout-main route-transition">
        {children}
      </main>
      <BottomNav />
    </div>
  );
}
